import React from "react";
import css from "./FooterView.module.css";
import {LinkView} from "Components";
import {heart0,github0,profileimg} from "Assets";


export default function FooterView(props){
    const {}=props;
    return (
        <footer className={`${css.footerview} ${props.className||""}`}>
            <div className={css.col0}>
                <img className={css.icon} alt="github logo" src={github0(mainColor)}/>
                <ul className={css.links}>
                    {statics.links.map(({name,url})=>(
                        <li key={name}>
                            <LinkView label={name} url={url}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={css.col1}>
                <a 
                    href="https://github.com/AhmedAyachi"
                    aria-label="author github page"
                    target="__blank"
                    className={css.authoricon} 
                    style={{backgroundImage:`url(${profileimg})`}}
                />
            </div>
        </footer>
    )
}

const statics={
    links:[
        {name:"vritra",url:"https://github.com/AhmedAyachi/Vritra"},
        {name:"cordova-vritra",url:"https://github.com/AhmedAyachi/Cordova-Vritra"},
        //{name:"vritra-scripts",url:"https://github.com/AhmedAyachi/Vritra-Scripts"},
    ],
}
